import { CardBox, Container, ContentBox, Icons, Row, Stack, Text } from '../../../components'
import palette from '../../../palette.json'

export function Bill() {
  return (
    <Container maxWidth="lg">
      <Stack spacing={0}>
        <CardBox title="Bill Payment">
          <ContentBox border>
            <Row>
              <Icons.NotificationImportant sx={{ color: palette.success, fontSize: '3rem' }} />
              <Stack spacing={0}>
                <Text.H5 sx={{ color: palette.success, display: 'flex' }}>Coming Soon!</Text.H5>
                <Text.Body>
                  You will soon be able to make contributions to GiveWise Canada using the Bill Payment function within
                  your online banking profile! Check back soon!
                </Text.Body>
              </Stack>
            </Row>
          </ContentBox>
        </CardBox>
      </Stack>
    </Container>
  )
}
